var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQrPlaceHolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "300px",
    height: "300px",
    viewBox: "-260 40 520 520",
    style: {
      enableBackground: "new -260 40 520 520",
      width: "100%"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_14_",
    className: "st0",
    points: "100,360 60,360 60,320 20.1,320 20.1,440.1 60,440.1 60,480 100,480  "
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_13_",
    x: 100,
    y: 480,
    className: "st0",
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_12_",
    x: 179.9,
    y: 480,
    className: "st0",
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "XMLID_11_",
    className: "st0",
    points: "220,320 179.9,320 179.9,360 139.9,360 139.9,480 179.9,480 179.9,440.1 220,440.1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_10_",
    x: 20.1,
    y: 480,
    className: "st0",
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_9_",
    x: -139.9,
    y: 159.9,
    className: "st0",
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-220,80v200h199.9V80H-220z M-60,239.9h-119.9V120h120v119.9H-60z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_6_",
    x: 100,
    y: 159.9,
    className: "st0",
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20.1,80v200H220V80H20.1z M179.9,239.9H60V120h120v119.9H179.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_3_",
    x: -139.9,
    y: 399.9,
    className: "st0",
    width: 40,
    height: 40
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M-220,320v200h199.9V320H-220z M-60,480h-119.9V360h120V480H-60z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQrPlaceHolder);
export default __webpack_public_path__ + "static/media/qrPlaceHolder.7f7ae5aeaa91e266899e160d8ac5fea4.svg";
export { ForwardRef as ReactComponent };